import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getOr } from 'lodash/fp';
import api from './api';

const name = 'organizations';

const fetchOrganizations = createAsyncThunk(
  'organizations/fetchOrganizations',
  async () => {
    const fn = api.fetch('');
    const response = await fn();
    return response;
  }
);

const fetchOrganization = createAsyncThunk(
  'fetchOrganization',
  async (orgId) => {
    const fn = api.fetch(orgId);
    const response = await fn();
    return response;
  }
);

const { actions, reducer } = {
  ...createSlice({
    name,
    initialState: {
      isLoading: false,
      error: false,
      data: [],
      organization: {},
    },
    extraReducers: (builder) => {
      builder
        // Fetch all organizations
        .addCase(fetchOrganizations.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(fetchOrganizations.fulfilled, (state, action) => {
          state.isLoading = false;
          state.data = action.payload;
        })
        .addCase(fetchOrganizations.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        })

        // Fetch organization
        .addCase(fetchOrganization.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(fetchOrganization.fulfilled, (state, action) => {
          state.isLoading = false;
          state.organization = action.payload;
        })
        .addCase(fetchOrganization.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        });
    },
  }),
};

const selectors = {
  selectIsLoading: (state) => getOr('', 'isLoading', state[name]),
  selectOrganization: (state) => getOr([], 'organization', state[name]),
  selectOrganizations: (state) => getOr([], 'data', state[name]),
};

export default {
  actions: {
    ...actions,
    fetchOrganization,
    fetchOrganizations,
  },
  selectors,
  reducer,
  name,
};
